import { Button, Divider, Form, Input } from 'antd';
import { POLICY_NAME } from '../../POLICY';
import { useTranslation } from 'react-i18next';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { useEffect } from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import BtnSave from './BtnSave';
import Sticky from 'react-sticky-el';
import { checkValidForm } from './Step1';
import { EXAMLE, INIT } from './init';
import TextBox from '../../Shared/TextBox';

const Step6 = (props) => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep6(true);
            })
            .catch(() => {
                props.setStep6(false);
            });
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.cctvRetainPersonalData) {
            onValuesChange(null, props.previewData?.cctvRetainPersonalData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'cctvRetentionTitleTh',
            'cctvRetentionTitleEn',
            'cctvRetentionContentTh',
            'cctvSecurityTitleTh',
            'cctvSecurityTitleEn',
            'cctvSecurityContentTh',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep6(check);
    };

    const cctvCompanyNameTh =
        props.cctvPolicy?.cctvCompanyNameTh || '[company_name]';
    const cctvCompanyNameEn =
        props.cctvPolicy?.cctvCompanyNameEn || '[company_name]';

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('How long and how we retain personal data', {
                    ns: POLICY_NAME.CCTV_POLICY,
                })}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="cctvRetainPersonalData"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.cctvRetainPersonalData}
            >
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Retention period personal data from CCTV', {
                            ns: POLICY_NAME.CCTV_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvRetentionTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvRetentionContentTh.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameTh
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvRetentionContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvRetentionTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvRetentionContentEn.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameEn
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvRetentionContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Divider />
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Security of Personal Data', {
                            ns: POLICY_NAME.CCTV_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvSecurityTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox code={EXAMLE.cctvSecurityContentTh} />
                    <Form.Item
                        className="mt-4"
                        name="cctvSecurityContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvSecurityTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox code={EXAMLE.cctvSecurityContentEn} />
                    <Form.Item
                        className="mt-4"
                        name="cctvSecurityContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Form.Item hidden name="cctvRetainPersonalDataId"></Form.Item>
                <Form.Item hidden name="cctvRetentionIsDisplay"></Form.Item>
                <Form.Item hidden name="cctvSecurityIsDisplay"></Form.Item>

                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave
                            loading={props.loadingSaveDraft}
                            saveDraft={props.saveDraft}
                        />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step6;
